module.exports = __webpack_public_path__ + "img/1337.495094bc.gif";